import { render } from "./cardheader.vue?vue&type=template&id=23eaf39a"
import script from "./cardheader.vue?vue&type=script&lang=js"
export * from "./cardheader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__